import React, { useContext } from 'react'
import styled from '@emotion/styled'
import dayjs from 'dayjs'

import { Link, SectionTitle } from '@jelly/ui'
import { ArrowActionCard } from '../ArrowActionCard'
import { SiteConfigContext } from '../SiteConfigProvider'

const RelatedContainer = styled.div`
	max-width: 950px;
	margin: 2rem 0;
`
const RelatedEndArticles = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: row;
	flex-flow: row wrap;
	margin: 1rem 0;

	a {
		margin-bottom: 1rem;
		width: 100%;

		${({ theme }) => theme.MQ.S} {
			height: 250px;
			margin-right: 1rem;
			max-width: 298px;
		}
	}
`
const HeaderContainer = styled.div`
	display: flex;
	flex-direction: column;

	${({ theme }) => theme.MQ.M} {
		align-items: center;
		flex-direction: row;
		a {
			border-left: 1px solid ${({ theme }) => theme.colors.gray[300]};
			padding-left: 1rem;
		}
		div {
			margin-right: 1rem;
		}
	}
`
const AdContainer = styled.div`
	margin: auto;
	width: 300px;

	${({ theme }) => theme.MQ.S} {
		margin: 0;
	}
`

export function RelatedEndTiles({ channel, listOfContent }) {
	const {
		siteConstants: { SITE_HOST },
	} = useContext(SiteConfigContext)
	const { name, slug } = !!channel ? channel : { name: 'Business.com', slug: 'content' }
	//trailing slash required on BDC but not BND
	const seeMoreForSite = SITE_HOST.includes('business.com') ? `${SITE_HOST}/${slug}/` : `${SITE_HOST}/${slug}`

	return (
		<RelatedContainer id="related-end-tiles">
			<HeaderContainer>
				<SectionTitle>{name}</SectionTitle>
				<Link href={seeMoreForSite} variant="primary">
					See More &gt;
				</Link>
			</HeaderContainer>
			<RelatedEndArticles>
				{listOfContent.slice(0, 5).map((article, i) => {
					const { canonical, dek, lastModified, published, sponsored, title } = article
					const isUpdated = dayjs(lastModified).isAfter(dayjs(published))
					const date = isUpdated ? lastModified : published
					return (
						<ArrowActionCard
							canonical={canonical}
							date={date}
							description={dek}
							isUpdated={isUpdated}
							key={`related-end-article-${i}`}
							sponsored={sponsored}
							title={title}
						/>
					)
				})}
				<AdContainer id="adunit-btf" />
			</RelatedEndArticles>
		</RelatedContainer>
	)
}
